<p>{{ 'DIPRSRegistration.confirmation.modal.description' | translate }}</p>


<div class="row td-toolbar">
  <div class="col-sm-6">
    <button type="button" class="btn btn-block td-btn-secondary-clear" (click)="continue.emit()" [dipseWebMetricEvent]="'myins:seamless:enrollment:warning:registration:ok:end:session'">
      {{ 'DIPRSRegistration.confirmation.modal.button.continue' | translate }}
    </button>
  </div>
  <div class="col-sm-6">
    <button type="button" class="btn btn-block td-btn-primary-light" (click)="close.emit()" [dipseWebMetricEvent]="'myins:seamless:enrollment:warning:registration:cancel:continue:registration'">
      {{ 'DIPRSRegistration.confirmation.modal.button.cancel' | translate }}
    </button>
  </div>
</div>
